import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Form,
    Input,
    Select,
    Card,
    Button,
    Row,
    Col,
    DatePicker,
} from 'antd';
import moment from 'moment';
import nationality from '../../JSON/nationality.json';
import phoneCodes from '../../JSON/phonecodes.json';
import './style.css';
import CustomSpin from '../CommonSpin';
import { Content } from 'antd/es/layout/layout';
import { useAuth } from '../../Context';
import initialJson from '../../JSON/initials.json';
import { createProfileRequest } from './Actions';
import { selectLoading, selectSuccessCreateProfileMsg } from './Selectors';
import { useNavigate } from 'react-router-dom';
import { ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Option } = Select;

const AddProfile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const [gender, setGender] = useState(null);
    const [stateValue, setStateValue] = useState(null);
    const [alternatephoneNumberLength, setPhoneLength] = useState([10]);
    // const [countryCallingCodes, setCallingCode] = useState('+91');
    const [alternatephoneNumber, setAlternatePhoneNumber] = useState(null);
    const [districtId, setDistrictId] = useState();
    const [countryCode, setCountryCode] = useState();
    const [initials, setinitials] = useState('Mr.');

    const { getCountries, countries, getState, states, getDistricts, districts, getLocalbodytype, localbodytype, getLocalbodys, localbodys } = useAuth();

    const countryList = countries;
    const requesting = useSelector(selectLoading);
    const datas = states;
    const district = districts;
    const localbodyTypes = localbodytype;
    const localbody = localbodys;
    
    const profileCreatedSuccess = useSelector(selectSuccessCreateProfileMsg);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;        

    if(profileCreatedSuccess) {
        navigate('/online-doctors-consultation');
    }
    
    useEffect(() => {
        getCountries();
        getState('IN');
        getDistricts();
        getLocalbodytype();        
    }, [dispatch]);
    

    const onSelectCountry = (value, option) => {
        
        const data = option.abc;        
        const selected = phoneCodes.find((item) => item.dial_code === data.countryCallingCodes[0]);

        setCountryCode(data.countryCallingCodes[0]);
        getState(data.alpha2);
                
        if(selected){
            setPhoneLength(selected.phLength);
        }
    };

    const onSelectState = (value) => {
        setStateValue(value);
    };

    const onSelectDistrict = (value, option) => {
        setDistrictId(option.abc);
    };

    const onSelectLocalBodyType = (value) => {
        getLocalbodys(districtId, value);
    };

    const changeCountryCode = (value) => {        
        const selected = phoneCodes.find((item) => item.id === value);
        if (selected) {            
            // setCallingCode(selected.dial_code);
            setPhoneLength(selected.phLength);
            setCountryCode(selected.dial_code);
        }        
        setAlternatePhoneNumber(null);
        form.resetFields(['secondaryContact']);
    };    

    const validatePhone = (rule, value) => {
        // If input is empty, skip validation
        if (!value || value.length === 0) {
            return Promise.resolve();
        }

        // Get allowed lengths (number or array)
        const allowed = alternatephoneNumberLength; // e.g., 10 or [10, 11]
        const allowedLengths = Array.isArray(allowed) ? allowed : [allowed];

        // Check that value contains only digits
        if (!/^[0-9]+$/.test(value)) {
            return Promise.reject(
                new Error(
                    langdata.Phonenumbernotvalid
                        ? langdata.Phonenumbernotvalid
                        : 'Phone number must contain only digits!'
                )
            );
        }

        // Check if input length matches any allowed length
        const isValidLength = allowedLengths.includes(value.length);

        if (!isValidLength) {
            return Promise.reject(
                new Error(
                    langdata.Phonenumbernotvalid
                        ? langdata.Phonenumbernotvalid
                        : 'Phone number not valid!'
                )
            );
        }

        // ✅ Passed all checks
        return Promise.resolve();
    };

    const validateName = (regex, message) => (_, value) => {
        if (!value || value.match(regex)) return Promise.resolve();
        return Promise.reject(message);
    };

    const handleSubmit = (value) => {
        const payload = {
            firstName: value.firstName,
            lastName:value.lastName,
            address: value.address,
            bloodGroup: value.bloodGroup,
            gender: gender,
            initials: initials,
            nationality: value.Country,
            residentCountry: value.residentCountry,
            district: value.district,
            state: value.state,
            lsg: value.localBodyValue,
            countryCode: countryCode,
            secondaryContact: value.secondaryContact,
            dateOfBirth: value.dateOfBirth
        };
        dispatch(createProfileRequest(payload));
        // dispatch({
        //     type: ADD_PROFILE_DETAILS,
        //     payload: values,
        //     gender,
        // });
    };

    const phoneOptions = phoneCodes.map((item) => (
        <Option key={item.id} value={item.id}>
            {item.dial_code}
        </Option>
    ));

    const selectBefore = (
        <Select
            showSearch
            style={{ width: 80 }}
            // defaultValue="+91"
            value={countryCode}
            onChange={changeCountryCode}
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children?.toLowerCase().includes(input.toLowerCase())
            }
        >
            {phoneOptions}
        </Select>
    );

    const changeInitials = (value) => {
        setinitials(value);
    };

    const selectInitials = (<Select
        // showSearch
        style={{ width: 100 }}
        defaultValue="Mr."
        onChange={changeInitials}
    >
        {initialJson.map((itm) => (
            <Option key={itm} value={itm}>
                {itm}
            </Option>
        ))};
    </Select>
    );

    const countryOptions =
    countryList?.map(
        (item) =>
            item.countryCallingCodes[0] && (
                <Option key={item.name} abc={item}>
                    {item.name}
                </Option>
            )
    ) || [];

    const stateOptions =
    datas?.data?.map((item) => <Option key={item}>{item}</Option>) || [];

    const districtOptions =
    district?.data?.map((item) => (
        <Option key={item.name} abc={item.id}>
            {item.name}
        </Option>
    )) || [];

    const localBodyTypeOptions =
    localbodyTypes?.data?.map((item) => (
        <Option key={item.id}>{item.name}</Option>
    )) || [];

    const localBodyOptions =
    localbody?.data?.map((item) => (
        <Option key={item.name}>{item.name}</Option>
    )) || [];

    const nationa = nationality.map((item, i) => (
        <Option key={i} value={item}>
            {item}
        </Option>
    ));

    // const phoneNumber = localStorage.getItem('cellphone');

    return (
        <Content>
            <div style={{ padding: 25 }}>
                <Row justify="center">
                    <Col xs={24} lg={16}>
                        <Card>
                            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                                <Form.Item
                                    label={langdata.FirstName ? langdata.FirstName : 'First Name'}
                                    name="firstName"
                                    rules={[
                                        { required: true, message: langdata.PleaseinputyourFirstName ? langdata.PleaseinputyourFirstName : 'Please input your First Name' },
                                        {
                                            validator: validateName(/^[a-zA-Z]*$/, 'Enter valid name'),
                                        },
                                    ]}
                                >
                                    <Input addonBefore={selectInitials} placeholder={langdata.FirstName ? langdata.FirstName : 'First Name'} />
                                </Form.Item>

                                <Form.Item
                                    label={langdata.LastName ? langdata.LastName : 'Last Name'}
                                    name="lastName"
                                    rules={[
                                        { required: true, message: langdata.PleaseinputyourLastName ? langdata.PleaseinputyourLastName : 'Please input your Last Name' },
                                        {
                                            validator: validateName(/^[a-zA-Z ]*$/, 'Enter valid name'),
                                        },
                                    ]}
                                >
                                    <Input placeholder={langdata.LastName ? langdata.LastName : 'Last Name'} />
                                </Form.Item>

                                <Form.Item
                                    label={langdata.PresentAddress ? langdata.PresentAddress : 'Present Address'}
                                    name="address"
                                    rules={[{ required: true, message: langdata.PleaseinputyourAddress ? langdata.PleaseinputyourAddress : 'Please input your Address' }]}
                                >
                                    <Input placeholder={langdata.Address ? langdata.Address : 'Address'} />
                                </Form.Item>

                                <Form.Item
                                    label={langdata.CountryofResidence ? langdata.CountryofResidence : 'Country of Residence'}
                                    name="residentCountry"
                                    rules={[{ required: true, message: langdata.Pleaseselectyourcountry ? langdata.Pleaseselectyourcountry : 'Please select your country!' }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder={langdata.Pleaseselectacountry ? langdata.Pleaseselectacountry : 'Please select a country'}
                                        onSelect={onSelectCountry}
                                        optionFilterProp="children"
                                    >
                                        {countryOptions}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label={langdata.State ? langdata.State : 'State'}
                                    name="state"
                                    rules={[{ required: true, message: langdata.Pleaseselectyourstate ? langdata.Pleaseselectyourstate : 'Please select your state!' }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder={langdata.Pleaseselectastate ? langdata.Pleaseselectastate : 'Please select a state'}
                                        onSelect={onSelectState}
                                        optionFilterProp="children"
                                    >
                                        {stateOptions}
                                    </Select>
                                </Form.Item>

                                {stateValue === 'Kerala' && (
                                    <>
                                        <Form.Item
                                            label={langdata.District ? langdata.District : 'District'}
                                            name="district"
                                            rules={[{ required: true, message: langdata.Pleaseselectyourdistrict ? langdata.Pleaseselectyourdistrict : 'Please select your district!' }]}
                                        >
                                            <Select
                                                showSearch
                                                placeholder={langdata.Pleaseselectadistrict ? langdata.Pleaseselectadistrict : 'Please select a district'}
                                                onSelect={onSelectDistrict}
                                            >
                                                {districtOptions}
                                            </Select>
                                        </Form.Item>

                                        <Form.Item
                                            label={langdata.LocalbodiesType ? langdata.LocalbodiesType : 'Local bodies Type'}
                                            name="localBody"
                                            rules={[{ required: true, message: langdata.Pleaseselectyourlocalbodytype ? langdata.Pleaseselectyourlocalbodytype : 'Please select your localbody type!' }]}
                                        >
                                            <Select
                                                showSearch
                                                placeholder={langdata.Pleaseselectalocalbodytype ? langdata.Pleaseselectalocalbodytype : 'Please select a localbody type'}
                                                onSelect={onSelectLocalBodyType}
                                            >
                                                {localBodyTypeOptions}
                                            </Select>
                                        </Form.Item>

                                        <Form.Item
                                            label={langdata.Localbody ? langdata.Localbody : 'Local body'}
                                            name="localBodyValue"
                                            rules={[{ required: true, message: langdata.Pleaseselectyourlocalbody ? langdata.Pleaseselectyourlocalbody : 'Please select your localbody!' }]}
                                        >
                                            <Select showSearch placeholder={langdata.Pleaseselectalocalbody ? langdata.Pleaseselectalocalbody : 'Please select a localbody'}>
                                                {localBodyOptions}
                                            </Select>
                                        </Form.Item>
                                    </>
                                )}

                                <Form.Item
                                    label={langdata.Nationality ? langdata.Nationality : 'Nationality'}
                                    name="Country"
                                    rules={[{ required: true, message: langdata.PleaseselectyourNationality ? langdata.PleaseselectyourNationality : 'Please select your Nationality!' }]}
                                >
                                    <Select showSearch placeholder={langdata.PleaseselectaNationality ? langdata.PleaseselectaNationality : 'Please select a Nationality'}>
                                        {nationa}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label={langdata.Gender ? langdata.Gender : 'Gender'}
                                    name="gender"
                                    rules={[{ required: true, message: langdata.Pleaseselectyourgender ? langdata.Pleaseselectyourgender : 'Please select your gender' }]}
                                >
                                    <Select onChange={setGender} placeholder={langdata.Pleaseselectgender ? langdata.Pleaseselectgender : 'Please select gender'}>
                                        <Option value="Male">{langdata.Male ? langdata.Male : 'Male' }</Option>
                                        <Option value="Female">{langdata.Female ? langdata.Female : 'Female' }</Option>
                                        <Option value="Others">{langdata.Others ? langdata.Others : 'Others'}</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label={langdata.AlternateNumber ? langdata.AlternateNumber : 'Alternate Number'}
                                    name="secondaryContact"
                                    rules={[{ validator: validatePhone }]}
                                >
                                    <Input
                                        addonBefore={selectBefore}
                                        placeholder={langdata.AlternatePhoneNumber ? langdata.AlternatePhoneNumber : 'Alternate Phone Number'}
                                        value={alternatephoneNumber}
                                        onChange={(e) => setAlternatePhoneNumber(e.target.value)}
                                    />
                                </Form.Item>

                                <Form.Item label={langdata.BloodGroup ? langdata.BloodGroup : 'Blood Group'} name="bloodGroup" rules={[{ required: true, message: 'Please select your Blood Group!' }]}>
                                    <Select placeholder={langdata.PleaseselectBloodGroup ? langdata.PleaseselectBloodGroup : 'Please select Blood Group'}>
                                        <Option value="A+">A+</Option>
                                        <Option value="A-">A-</Option>
                                        <Option value="B+">B+</Option>
                                        <Option value="B-">B-</Option>
                                        <Option value="O+">O+</Option>
                                        <Option value="O-">O-</Option>
                                        <Option value="AB+">AB+</Option>
                                        <Option value="AB-">AB-</Option>
                                        <Option value="Not Specified">{langdata.NotSpecified ? langdata.NotSpecified : 'Not Specified' }</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item label={langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth'} name="dateOfBirth" rules={[{ required: true, message: 'Please select your Date of birth!' }]}>
                                    <DatePicker disabledDate={(current) => current >= moment().endOf('day')} />
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        <ButtonText text = {langdata.Submit ? langdata.Submit : 'Submit'} />
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
                <CustomSpin spinning = {requesting} />
            </div>
        </Content>
    );
};

export default AddProfile;
